import { Validator } from '@vista-digital/validator';
import { runInAction } from 'mobx';
import { configurationSettings } from '../../../../configuration/configuration-settings';
import { TicketingMode } from '../../../../configuration/types/order/ticketing-mode';
import { areArraysEquivalent } from '../../../../utils/equivalence-utils';
import { logger } from '../../../../utils/logger';
import { orderSeatValidator } from '../../../../utils/validators/order/order-seat';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { getReservedOrderSeatIdsForShowtime } from '../../selectors/seats/get-reserved-order-seat-ids-for-showtime';
import { getOrderTicketsForShowtime } from '../../selectors/tickets/get-order-tickets-for-showtime';
import { orderDomainStore } from '../../store';
const selectedSeatsValidator = Validator.array({ items: orderSeatValidator });
export const setOrderSeatsForShowtime = (showtimeId, selectedSeats) => {
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot set seats. Provided showtimeId is invalid.');
    }
    if (!selectedSeatsValidator(selectedSeats, logger.error, 'selectedSeats')) {
        throw new Error('Cannot set seats. Provided selectedSeats are invalid.');
    }
    const seatsMatchReservedSeats = areArraysEquivalent(getReservedOrderSeatIdsForShowtime(showtimeId), selectedSeats.map(s => s.seatId));
    // Nothing to update
    if (seatsMatchReservedSeats)
        return;
    const { ticketingMode } = configurationSettings.data.order;
    const isSeatFirstOrdering = ticketingMode === TicketingMode.SeatFirst;
    runInAction(() => {
        orderDomainStore.data.selections.showtime = {
            showtimeId,
            seats: selectedSeats,
            tickets: isSeatFirstOrdering ? [] : getOrderTicketsForShowtime(showtimeId)
        };
    });
};
